import { Component, Input } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';

@Component({
  selector: 'app-tree-distribution',
  templateUrl: './tree-distribution.component.html',
  styleUrls: ['./tree-distribution.component.scss']
})
export class TreeDistributionComponent {


  childrendata: any = [];
  childindex: number = -1;
  showchilddialog: boolean = false;
  parents: any = [];

  startDate: Date  = new Date('09-09-2023');
  endDate: Date = new Date();
  today: Date = new Date();
  limit: number = 10;
  graphData: any;


  showchildrenof(_t6: any, item: any) {
      this.childrendata = _t6;


      if(this.parents[this.parents.length - 1] != item ) {
        if(this.parents.length > 1 ) {
          this.parents.pop();
        } else {
          this.parents.push(item);
        }
      }

      this.showchilddialog = true;
  }

  onDialogHide() {
    this.parents = []
  }

  staticURL = GlobalConstants.staticFilesURL;

  constructor( private dataService: DataService,) {}

  @Input() data: any;
  
  displayData: any[] = [];

  async ngOnInit() {
    this.displayData = await this.getDataFromArg(this.data);
  }



  // async getDataFromArg(data: any) {
  //   let res = await this.dataService.postData('dashboards/dynamic-aggregation', {
  //     "aggregation": data.aggregation,
  //     "tableName": data.table
  //   }); 

  //   return res.data;
  // }

  async getDataFromArg(startDate?: Date, endDate?: Date, limit: number = 10) {

    // let res = await this.dataService.postData('dashboards/dynamic-aggregation', {
    //   "aggregation": this.data.aggregation,
    //   "tableName": this.data.table,
    //   "timeRange":  (startDate && endDate) ? { startDate: startDate, endDate: endDate } : null,
    //   "limit": limit
    // }); 

    // return res.data;

    let managerOu: any = localStorage.getItem('managerOus');

    managerOu = managerOu ? JSON.parse(managerOu) : null;

    if (this.data.tag && this.data.tag === 'MANAGER' && managerOu && managerOu.length > 0) {
      let res = await this.dataService.postData(
        'dashboards/dynamic-aggregation',
        {
          aggregation: this.data.aggregation,
          tableName: this.data.table,
          timeRange: (startDate && endDate) ? { startDate: startDate, endDate: endDate } : null,
          managerOus: managerOu,
          pre_arg: this.data.pre_arg ? this.data.pre_arg : null,
          limit: limit
        }
      );
      return res.data;
    } else {
      let res = await this.dataService.postData(
        'dashboards/dynamic-aggregation',
        {
          aggregation: this.data.aggregation,
          tableName: this.data.table,
          timeRange:  (startDate && endDate) ? { startDate: startDate, endDate: endDate } : null,
          pre_arg: this.data.pre_arg ? this.data.pre_arg : null,
          limit: limit
        }
      );
      return res.data;
    }
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false
    }
  }

  async onLimitChange() {

    this.displayData = await this.getDataFromArg(this.startDate, this.endDate, this.limit);
    // this.chartData = await this.makeChart(this.graphData)
    
  }

  async onDateChange() {
    this.displayData = await this.getDataFromArg(this.startDate, this.endDate, this.limit);
    // this.chartData = await this.makeChart(this.graphData)
  }

  async generateDateArray(startDate: Date, endDate: Date) {
    const dateArray = [];
    const currentDate = new Date(startDate);
  
    while (currentDate <= endDate) {
      const day = currentDate.getDate().toString().padStart(2, '0');
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
      const year = currentDate.getFullYear();
      const dateString = `${day}-${month}-${year}`;
      dateArray.push(dateString);
  
      // Move to the next day
      currentDate.setDate(currentDate.getDate() + 1);
    }
  
    return dateArray;
  }



}
